import { render, staticRenderFns } from "./CryptomatFeesTable.vue?vue&type=template&id=4f0adf3a&scoped=true&"
import script from "./CryptomatFeesTable.vue?vue&type=script&lang=js&"
export * from "./CryptomatFeesTable.vue?vue&type=script&lang=js&"
import style0 from "./CryptomatFeesTable.vue?vue&type=style&index=0&id=4f0adf3a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f0adf3a",
  null
  
)

export default component.exports